export default __webpack_public_path__ + "static/media/Bedroom.cdcb2aa7.png";